// import { doc } from 'prettier';
import LazyLoad from "vanilla-lazyload";
import { scrollRefresh } from "./animatePage.js";

const init = () => {
  const myPromise = new Promise((resolve, reject) => {
    const lazyload = new LazyLoad({
      // use_native: true,
      elements_selector: ".js-lazy-img",
      callback_loaded: (el) => {
        // console.log(el, "Image Loaded");
        const target = el;
        const targetwrapper = target.closest(".js-article-wrapper");
        const statsTextWidget = document.querySelector(".js-stats-section");
        if (targetwrapper !== null && statsTextWidget !== null) {
          // console.log(el);
          scrollRefresh();
        }
      }
    });

    resolve();
  });

  return myPromise;
};

export { init };
